import * as React from "react";
import SpeakerNotes from "@material-ui/icons/SpeakerNotes";
import LocalLibrary from "@material-ui/icons/LocalLibrary";
import QuestionAnswer from "@material-ui/icons/QuestionAnswer";
import Mic from "@material-ui/icons/RecordVoiceOver";
import AccountBox from "@material-ui/icons/AccountBox";
import Person from "@material-ui/icons/Person";
import Subject from "@material-ui/icons/Subject";
import List from "@material-ui/icons/List";
import Done from "@material-ui/icons/Done";
import FormatQuote from "@material-ui/icons/FormatQuote";
import InsertDriveFile from "@material-ui/icons/InsertDriveFile";
import { AbstractDocumentKind } from "../model/autogen/AbstractDocumentKind";
import { SearchableContentType } from "../model/autogen/SearchableContentType";

export const DOCUMENT_TYPE_ICONS = {
    [AbstractDocumentKind.DebateNotes]: <SpeakerNotes />,
    [AbstractDocumentKind.FAQ]: <QuestionAnswer />,
    [AbstractDocumentKind.IssueBrief]: <LocalLibrary />,
    [AbstractDocumentKind.Achievement]: <Done />,
    [AbstractDocumentKind.Resource]: <InsertDriveFile />,
    [AbstractDocumentKind.MediaLines]: <Mic />,
    [AbstractDocumentKind.ProfileOfMP]: <AccountBox />,
    [AbstractDocumentKind.Person]: <Person />,
    [AbstractDocumentKind.OpinionEditorial]: <Subject />,
    [SearchableContentType.Quote]: <FormatQuote />,
    //[SearchableContentType.Tweet]: <Message />,
    ["Speaking List"]: <List />
}



// WEBPACK FOOTER //
// ./src/components/document-icons.tsx